import StockBalanceRpt from "../../pages/stock/stock";
export const stockMenus = [
    {
        menuCode: 'STOCK',
        menuComponent: <StockBalanceRpt />
    },
];